import Vue from 'vue'
import Router from 'vue-router'

//电脑端
import PcHomePage from "../computer/PcHomePage";
import PcFirstPage from "../computer/PcFirstPage";
import PcAboutUs from "../computer/PcAboutUs";
import PcCompanyIntroduce from "../computer/second/PcCompanyIntroduce";
import PcHonorQualifications from "../computer/second/PcHonorQualifications";
import PcCorporateCulture from "../computer/second/PcCorporateCulture";
import PcProductCenter from "../computer/PcProductCenter";
import PcNewsCenter from "../computer/PcNewsCenter";
import PcCommonQuestions from "../computer/second/PcCommonQuestions";
import PcIndustryQuestions from "../computer/second/PcIndustryQuestions";
import PcQuestionIntroduce from "../computer/second/PcQuestionIntroduce";
import PcContactUs from "../computer/PcContactUs";

//移动端
import MobileHomePage from "../mobile/MobileHomePage";
import MobileFirstPage from "../mobile/MobileFirstPage";
import MobileProductCenter from "../mobile/MobileProductCenter";
import MobileAboutUs from "../mobile/MobileAboutUs";
import MobileCompanyIntroduce from "../mobile/second/MobileCompanyIntroduce";
import MobileHonorQualification from "../mobile/second/MobileHonorQualification";
import MobileNewsCenter from "../mobile/MobileNewsCenter";
import MobileIndustryQuestions from "../mobile/second/MobileIndustryQuestions";
import MobileCommonQuestions from "../mobile/second/MobileCommonQuestions";
import MobileQuestionIntroduce from "../mobile/second/MobileQuestionIntroduce";
import MobileContactUs from "../mobile/MobileContactUs";

Vue.use(Router)

const router = new Router({
  mode: 'history',   //去掉路径下的#号
  routes: [
    //电脑端
    {
      path: '/PcHomePage',
      name: 'PcHomePage',
      component: PcHomePage,
      children: [{
        path: '/',
        name: 'PcFirstPage',
        component: PcFirstPage,
      }, {
        path: '/PcAboutUs',
        name: 'PcAboutUs',
        component: PcAboutUs,
        children: [{
          path: '/PcCompanyIntroduce',
          name: 'PcCompanyIntroduce',
          component: PcCompanyIntroduce,
        }, {
          path: '/PcHonorQualifications',
          name: PcHonorQualifications,
          component: PcHonorQualifications,
        }, {
          path: '/PcCorporateCulture',
          name: 'PcCorporateCulture',
          component: PcCorporateCulture,
        }
        ]
      }, {
        path: '/PcProductCenter',
        name: 'PcProductCenter',
        component: PcProductCenter,
      }, {
        path: '/PcNewsCenter',
        name: 'PcNewsCenter',
        component: PcNewsCenter,
        children: [{
          path: '/',
          name: 'PcIndustryQuestions',
          component: PcIndustryQuestions,
        }, {
          path: '/PcCommonQuestions',
          name: 'PcCommonQuestions',
          component: PcCommonQuestions,
        }, {
          path: '/PcQuestionIntroduce',
          name: 'PcQuestionIntroduce',
          component: PcQuestionIntroduce,
        }]
      }, {
        path: '/PcContactUs',
        name: 'PcContactUs',
        component: PcContactUs,
      }]
    },
    // 移动端
    {
      path: '/MobileHomePage',
      name: 'MobileHomePage',
      component:MobileHomePage,
      children: [{
        path: '/',
        name: 'MobileFirstPage',
        component: MobileFirstPage,
        // meta:{
        //   keepAlive:true,
        // }
      }, {
        path: '/MobileAboutUs',
        name: 'MobileAboutUs',
        component: MobileAboutUs,
        children: [{
          path: '/',
          name: 'MobileCompanyIntroduce',
          component: MobileCompanyIntroduce,
        }, {
          path: '/MobileHonorQualification',
          name: 'MobileHonorQualification',
          component: MobileHonorQualification,
        }]
      }, {
        path: '/MobileProductCenter',
        name: 'MobileProductCenter',
        component: MobileProductCenter,
      }, {
        path: '/MobileNewsCenter',
        name: 'MobileNewsCenter',
        component: MobileNewsCenter,
        children: [{
          path: '/',
          name: 'MobileIndustryQuestions',
          component: MobileIndustryQuestions,
        }, {
          path: '/MobileCommonQuestions',
          name: 'MobileCommonQuestions',
          component: MobileCommonQuestions,
        }, {
          path: '/MobileQuestionIntroduce',
          name: 'MobileQuestionIntroduce',
          component: MobileQuestionIntroduce,
          meta:{
            keepAlive:true,
          }
        }]
      }, {
        path: '/MobileContactUs',
        name: 'MobileContactUs',
        component: MobileContactUs,
      },]
    }
  ]
})

//输出路由导向
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js